import type { ReactNode } from 'react'
import { View } from 'react-native'

import { CardHeader } from '@/src/elements/card'
import { CommunityThumbnail } from '@/src/features/community/ui/components/CommunityThumbnail'
import { TEST_ID } from '@/src/general/constants/testId'
import { getImageUrl } from '@/src/general/utils/getImageUrl'

import type { TPublicationApi } from '../../../api/types/getPublication.types'
import { PublicationUpdate, type TPublicationUpdateProps } from '../PublicationUpdate'

export type TPublicationCardHeaderProps = {
  showPublicationDate?: boolean
  showOptions?: boolean
  publication: Pick<TPublicationApi, 'hasPrayed' | 'id' | 'isFavorite'> & {
    community: Pick<TPublicationApi['community'], 'name' | 'picture'> & TPublicationUpdateProps['community']
  }
}

export const PublicationCardHeader = ({
  showPublicationDate,
  showOptions = true,
  publication,
}: TPublicationCardHeaderProps): ReactNode => {
  const {
    community: { name: communityName, picture: communityPicture },
    hasPrayed,
  } = publication

  const contrast = hasPrayed ? undefined : 'low'
  const colors = hasPrayed ? 'success' : 'default'

  return (
    <CardHeader className="flex flex-row items-start justify-between gap-3 p-0">
      {!showPublicationDate && (
        <CommunityThumbnail
          title={communityName}
          titleProps={{
            colors,
            ...(hasPrayed && { contrast: 'high' }),
            className: 'flex-1',
          }}
          ellipsis={false}
          subtitleProps={{ colors, contrast }}
          showImage
          imgSource={getImageUrl(communityPicture)}
          wrapperClassName="flex-1"
        />
      )}
      {showOptions && (
        <View>
          <PublicationUpdate
            buttonSize="sm"
            buttonColors={colors}
            publicationId={publication.id}
            isFavorite={publication.isFavorite}
            community={publication.community}
            testID={TEST_ID.PUBLICATION_CARD.OPTIONS_BUTTON}
          />
        </View>
      )}
    </CardHeader>
  )
}
